export default class SupportAbstractServices {
  static getContactUsReferenceData() {
    logger.error('Support:: getContactUsReferenceData() not implemented');
  }

  static postContactUsFeedback() {
    logger.error('Support: postContactUsFeedback() not implemented');
  }

  static getContactUsConfirmationRelatedArticles() {
    logger.error('Support: getContactUsConfirmationRelatedArticles() not implemented');
  }
}
